<template>
    <div id="CustomerList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="page-name">Customer Login Report
                <!-- Button for Clear Cache -->
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content customer-login-report">
                    <data-table-filter-config :moduleName="'customerLogin'" ref="filterReadingList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                    <div class="data-table bg-white overflow-hidden">
                      <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                      <section class="data-table bg-white">
                          <custom-pagination
                              :page-changed="onPageChange"
                              :per-page-changed="onPerPageChange" :moduleName="'customerLogin'" :position="'top'">
                          </custom-pagination>

                          <vue-good-table
                              ref="CustomerReportTable"
                              mode="remote"
                              title="Customer"
                              @on-page-change="onPageChange"
                              @on-selected-rows-change="selectionChanged"
                              @on-column-filter="onColumnFilter"
                              @on-per-page-change="onPerPageChange"
                              @on-sort-change="onSortChange"
                              :totalRows="totalRecords"
                              :columns="userColumns"
                              :rows="rows"
                              :pagination-options="{
                                  enabled: false,
                                  position: 'both',
                                  perPage: perPage,
                                  perPageDropdown:dropDownPerPage,
                                  dropdownAllowAll: false,
                              }"

                              :search-options="{
                              enabled: false,
                              }">
                          </vue-good-table>
                          <custom-pagination
                              :page-changed="onPageChange"
                              :per-page-changed="onPerPageChange">
                          </custom-pagination>
                      </section>
                    </div>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>


import Vue from "vue";
import EventBus from "./../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "CustomerList",
        metaInfo() {
            return {
                title: "Customer Login Report | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Email',
                    field: 'email',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Phone',
                    field: 'work_phone',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Logged In Time',
                    field: 'loggedin',
                    fpFieldType:"date",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Logged Out Time',
                    field: 'loggedout',
                    fpFieldType:"date",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Difference',
                    field: 'difference',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Ex.10 - 20 (Minutes)", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Active', 'Unverified'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            customer_value: false,
            loading:false,
            pageKey:"_customer_login_report_list_",
            action:'list',
            batchProcess:0,
            batchNum:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_customer') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_customer') {
                            self.customer_value = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.CustomerReportTable.unselectAllInternal();
            },
            // exportReports: function() {
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.serverParams.page = 1 ;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                    field:('description');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || filters.name || filters.code || filters.description ) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var self = this;
                if(self.customerVal == 'unsynccustomer'){
                self.flag = 'unsynccustomer';
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    action:self.action
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/report/customer-login",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {

                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    if ( self.action == "export" ) {

                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }

                                }

                                self.action = "list";
                                self.loadList();
                                return;

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'customer-login-report-list');
                    }
                });
            },

            customerDelete() {
                var data = this.$refs['listCustomerTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listCustomerTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Customer? ')) {
                    self.loading = true;
                    $("#deleteCustomerBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/customer/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteCustomerBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'customer-login-report-delete');
                        }
                    });
                }
            },

            syncCustomer() {

                var self = this;
                self.loading = true;
                $("#syncCustomerBtn").text("Syncing...");
                $("#syncCustomerBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/sync-customer",
                    type: "GET",
                    // data: 'id=' + use,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {

                        self.loading = false;
                        $("#syncCustomerBtn").text("Sync");
                        $("#syncCustomerBtn").prop("disabled", false);

                        if (data.status == 'success') {

                            self.$swal({
                                // title: data.content + " " ,
                                text: data.content + " Customer are Sync.",
                                type: "success",
                                confirmButtonText: "Confirm",
                            }).then(result => {
                                if (result.value) {
                                        self.loadList();
                                    }
                                });
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $("#syncCustomerBtn").text("Sync");
                        $("#syncCustomerBtn").prop("disabled", false);

                        self.generateStatusCodeMessage(jqXHR,false,'sync-customer-report');
                    }
                });

            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/reports/CustomerLoginReport.vue